import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Row,
  Col,
  Input,
  Button,
} from "@lockerpm/design";

import commonComponents from "../../../components/common";

import global from "../../../config/global";
import common from "../../../utils/common";

const CheckScam = () => {
  const { t } = useTranslation();
  const { PageHeader } = commonComponents;

  const locale = useSelector((state) => state.system.locale);
  
  const [url, setUrl] = useState('');

  const handleCheckScam = () => {
    const isValid = global.patterns.LINK.test(url) || global.patterns.PHONE.test(url);
    if (isValid) {
      common.openNewTab(`${global.urls.DOC_LINKS[locale]?.CHECK_SCAM_URL}/${encodeURIComponent(url)}`)
    } else {
      global.pushError({
        message: t('notification.error.check_scam.url_invalid')
      })
    }
  }

  return (
    <div className="check-scam layout-content">
      <PageHeader
        title={t('check_scam.title')}
        subtitle={t('check_scam.description')}
        actions={[]}
      />
      <div className="mt-4">
        <Row gutter={[16, 16]}>
          <Col lg={8} span={24}>
            <div className="flex items-center gap-3 w-full"> 
              <Input
                value={url}
                placeholder={t('check_scam.placeholder')}
                onChange={(e) => setUrl(e.target.value)}
              />
              <Button
                type="primary"
                onClick={handleCheckScam}
              >
                {t('button.check')}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default CheckScam;